import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TooltipBaseComponent } from "app/common/tooltip-base/tooltip-base.component";
import { ClickElsewhereDirective } from "../../directives/click-elsewhere.directive";
import { MoreInfoTooltipComponent } from "../more-info-tooltip/more-info-tooltip.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormInputComponent } from "../form-input/form-input.component";

@Component({
  selector: "app-password-input",
  templateUrl: "./password-input.component.html",
  styleUrls: ["./password-input.component.scss"],
  imports: [
    ClickElsewhereDirective,
    MoreInfoTooltipComponent,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FormInputComponent
  ]
})
export class PasswordInputComponent extends TooltipBaseComponent {
  @Input() password = "";
  @Input() isBusiness = false;
  @Input() isTaxAdviser = false;
  @Input() isSubaccount = false;
  @Input() isMaster = false;
  @Input() isSimplePassword = false;
  @Output() passwordChange = new EventEmitter<string>();
  @Input() isValidated = false;
  @Output() isValidatedChange = new EventEmitter<boolean>();
  @Input() errors = [];
  hasMinLength = false;
  hasUppercase = false;
  hasSpecialChar = false;

  checkPassword(value: string): void {
    this.password = value;

    if (this.isSimplePassword) {
      if (value !== null && value !== undefined && value !== "") this.isValidated = true;
      else this.isValidated = false;
    } else {
      this.hasUppercase = /[A-Z]/.test(value);
      this.hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

      if (this.isMaster || this.isSubaccount || this.isTaxAdviser) {
        this.hasMinLength = value.length >= 24;
      } else if (this.isBusiness) {
        this.hasMinLength = value.length >= 15;
      } else {
        this.hasMinLength = value.length >= 12;
      }

      const validated = this.hasMinLength && this.hasUppercase && this.hasSpecialChar;
      this.isValidated = validated;
    }

    this.passwordChange.emit(this.password);
    this.isValidatedChange.emit(this.isValidated);
  }

  public lengthValidationText(): string {
    if (this.isMaster || this.isSubaccount || this.isTaxAdviser) {
      return "PASSWORD_VALIDATOR.CONDITION_1.24_SIGNS";
    } else if (this.isBusiness) {
      return "PASSWORD_VALIDATOR.CONDITION_1.15_SIGNS";
    } else {
      return "PASSWORD_VALIDATOR.CONDITION_1.12_SIGNS";
    }
  }
}
